import React from "react";
import PropTypes from "prop-types";
import { reduxForm } from "redux-form";
import styles from "components/settings/account-name-and-email-settings.scss";
import { FormButton, renderFormElement, renderFormNumberElement } from "components/common/form-elements";

const StatelessAccountNameAndEmailForm = ({ emailPin, onSaveNameAndEmail, slug }) => (
  <form onSubmit={ (e) => { e.preventDefault(); onSaveNameAndEmail(); } }>
    <div>This is the name for your account you will see in emails.</div>
    <div className={ styles["form-element"] }>
      { renderFormElement("Account Name", "label", "text") }
    </div>

    <h2>Submission Email Address</h2>
    <div>
      Use your Email Address to send documents, business cards and documents from anywhere.
      Your PIN is part of this address and makes it difficult for someone to spam your account.
    </div>

    <div className={ styles.email }>
      { renderFormElement("Account slug", "slug", "text") }
      <span>.</span>
      { renderFormNumberElement("Email pin", "emailPin", "0", "9999", "1") }
      <span>@sqrl.st</span>
    </div>

    <div>Send your documents to: { `${slug}.${emailPin}@sqrl.st` }</div>
    <FormButton text={ "Save Changes" } />
  </form>
);

StatelessAccountNameAndEmailForm.propTypes = {
  emailPin: PropTypes.string.isRequired,
  onSaveNameAndEmail: PropTypes.func.isRequired,
  slug: PropTypes.string.isRequired
};

export const AccountNameAndEmailForm = reduxForm({ form: "accountNameAndEmailForm" })(StatelessAccountNameAndEmailForm);



// WEBPACK FOOTER //
// ./src/js/components/settings/account-name-and-email-form.jsx